import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App.js';
import ModalContext from './Context/modal';

const AppRouter = () => {
  const [modalData, setModalData] = useState({});
  const [showMediaModal, setShowMediaModal] = useState(false);
  const slug = document.querySelector('#root').getAttribute('data-slug');

  return (
    <ModalContext.Provider
      value={{
        modalData,
        setModalData,
        showMediaModal,
        setShowMediaModal,
      }}
    >
      <Router>
        <Routes>
          <Route path={`/interactives/${slug}/app/glossary`} element={<App route="glossary" />} />
          <Route path={`/interactives/${slug}/app/:person/:slide`} element={<App />} />
          <Route path={`/interactives/${slug}/app/:person`} element={<App />} />
          <Route path={`/interactives/${slug}/app`} element={<App />} />
        </Routes>
      </Router>
    </ModalContext.Provider>
  );
};

export default AppRouter;
